// extracted by mini-css-extract-plugin
module.exports = {"style":{"fontFamily":"'__sanomatSans_305d60', '__sanomatSans_Fallback_305d60'"},"className":"__className_305d60","variable":"__variable_305d60"};